import { Subject } from "rxjs";

/**
 * @summary Contains the Promise for the http request, and a cancellation token to allow cancellation for long running requests
 */
export class HttpResult<T>
{
    public cancellation: Subject<boolean>;
    public response: Promise<T>;

    constructor()
    {
        this.cancellation = new Subject<boolean>();
    }

 
    public static async awaitResponses(httpResponses: HttpResult<any>[])
    {
        let faults = [];        

        for (let response of httpResponses) {

            try {
              await response.response;
            }
            catch (error) {
              faults.push(error);
            }
        }

        return { "faults":  faults };      
    }
}